import React, { useEffect, useState } from "react";
import axios from "axios";
import { Col, Row, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import { BASEURL } from "../../../constant/api";

const StepFour = ({
  handleNextStep,
  isEdit,
  outletId,
  allStepsData,
  setAllFormData,
}) => {
  const token = useSelector((state) => state.auth?.token);
  const [touchedError, setTouchedError] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState({
    newPassword: false,
    confirmNewPassword: false,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setError,
    setValue,
  } = useForm();

  useEffect(() => {
    if (!allStepsData) {
      return;
    }
    setValue("email", allStepsData?.email ?? "");
    setValue("mobile", allStepsData?.mobile ?? "");
    setValue("name", allStepsData?.name ?? "");
    setValue("password", allStepsData?.password ?? "");
    setValue("confirmNewPassword", allStepsData?.password ?? "");
  }, [allStepsData, setValue]);

  const onSubmit = async (data) => {
    if (!isEdit && data.password !== data.confirmNewPassword) {
      setError("confirmNewPassword", { type: "manual" });
      return;
    }

    setLoader(true);
    try {
      const response = await axios.post(
        `${BASEURL.PORT}/admin/vendor/updateStepFour`,
        {
          ...data,
          outletId,
        },
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
      );

      const payload = response?.data;
      toast.success(
        payload?.message || "Outlet manager details updated successfully.",
      );
      setAllFormData((prev) => ({
        ...prev,
        ...data,
      }));
      handleNextStep(5);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Unable to save manager details.",
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb
            title="Add/Edit Outlet"
            links={[
              { to: "/", name: "Home" },
              { to: "/vendors", name: "Outlets" },
            ]}
          />
        </div>
        <div className="col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>{isEdit ? "Edit Outlet" : "Add Outlet"}</h6>
            </div>
            <div className="ms-panel-body">
              <form
                className="needs-validation"
                onSubmit={handleSubmit(onSubmit)}
                noValidate
              >
                <p>
                  Fill the Required Details of Person Incharge handling the
                  Bookings and Guest Communications.
                </p>
                <div className="form-vendor-regi">
                  <div className="form-vendor">
                    <Row>
                      <Col md={12}>
                        <div style={{ marginTop: "20px" }}>
                          <label htmlFor="name">
                            Name<span className="error">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              name="name"
                              id="name"
                              placeholder="Name"
                              className={`form-control ${
                                touchedError
                                  ? errors.name
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                              {...register("name", { required: true })}
                            />
                            {errors.name?.type === "required" && (
                              <div className="invalid-feedback">
                                The name field is required.
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="form-group">
                          <label htmlFor="email">
                            Email Address<span className="error">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              type="email"
                              name="email"
                              id="email"
                              placeholder="Email Address"
                              className={`form-control ${
                                touchedError
                                  ? errors.email
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                              {...register("email", {
                                required: true,
                                pattern:
                                  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                              })}
                            />
                            {errors.email?.type === "required" && (
                              <div className="invalid-feedback">
                                The email field is required.
                              </div>
                            )}
                            {errors.email?.type === "pattern" && (
                              <div className="invalid-feedback">
                                The email must be a valid email address.
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="form-group ">
                          <label htmlFor="password">
                            Password<span className="error">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              type={
                                isPasswordVisible.newPassword
                                  ? "text"
                                  : "password"
                              }
                              name="password"
                              id="password"
                              placeholder="Password"
                              className={`form-control ${
                                touchedError
                                  ? errors.password
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                              {...register("password", {
                                required: true,
                                pattern: /.{8,}/,
                              })}
                            />

                            <a
                              href="/#"
                              onClick={(event) => {
                                event.preventDefault();
                                setIsPasswordVisible((prev) => ({
                                  ...prev,
                                  newPassword: !prev.newPassword,
                                }));
                              }}
                            >
                              {isPasswordVisible.newPassword ? (
                                <i className="fas fa-eye"></i>
                              ) : (
                                <i className="fas fa-eye-slash"></i>
                              )}
                            </a>

                            {errors.password?.type === "required" && (
                              <div className="invalid-feedback">
                                The password field is required.
                              </div>
                            )}
                            {errors.password?.type === "pattern" && (
                              <div className="invalid-feedback">
                                Password must be 8 characters long.
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>

                      {!isEdit && (
                        <Col md={12}>
                          <div className="form-group">
                            <label htmlFor="confirmNewPassword">
                              Re-Confirm Password
                              <span className="error">*</span>
                            </label>
                            <div className="input-group">
                              <input
                                type={
                                  isPasswordVisible.confirmNewPassword
                                    ? "text"
                                    : "password"
                                }
                                name="confirmNewPassword"
                                id="confirmNewPassword"
                                placeholder="Confirm New Password"
                                className={`form-control ${
                                  touchedError
                                    ? errors.confirmNewPassword
                                      ? "is-invalid"
                                      : "is-valid"
                                    : ""
                                }`}
                                {...register("confirmNewPassword", {
                                  required: true,
                                  pattern: /.{8,}/,
                                })}
                              />
                              <a
                                href="/#"
                                onClick={(event) => {
                                  event.preventDefault();
                                  setIsPasswordVisible((prev) => ({
                                    ...prev,
                                    confirmNewPassword:
                                      !prev.confirmNewPassword,
                                  }));
                                }}
                              >
                                {isPasswordVisible.confirmNewPassword ? (
                                  <i className="fas fa-eye"></i>
                                ) : (
                                  <i className="fas fa-eye-slash"></i>
                                )}
                              </a>
                              {errors.confirmNewPassword?.type ===
                                "required" && (
                                <div className="invalid-feedback">
                                  The re-confirm password field is required.
                                </div>
                              )}
                              {errors.confirmNewPassword?.type ===
                                "pattern" && (
                                <div className="invalid-feedback">
                                  Re-confirm password must be 8 characters long.
                                </div>
                              )}
                              {errors.confirmNewPassword?.type === "manual" && (
                                <div className="invalid-feedback">
                                  Password and re-confirm password does not
                                  match.
                                </div>
                              )}
                            </div>
                          </div>
                        </Col>
                      )}

                      <Col md={12}>
                        <div className="form-group ">
                          <label htmlFor="mobile">
                            Phone<span className="error">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              name="mobile"
                              id="mobile"
                              placeholder="Phone"
                              className={`form-control ${
                                touchedError
                                  ? errors.mobile
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                              {...register("mobile", {
                                required: true,
                                pattern: /^[0-9]{10}$/gm,
                              })}
                            />
                            {errors.mobile?.type === "required" && (
                              <div className="invalid-feedback">
                                This field is required.
                              </div>
                            )}
                            {errors.mobile?.type === "pattern" && (
                              <div className="invalid-feedback">
                                Please enter a valid phone number.
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-md-6">
                    <button
                      className="steps-btn float-left"
                      type="button"
                      onClick={() => handleNextStep(3)}
                    >
                      <i>&#8592;</i> Previous
                    </button>
                  </div>
                  <div className="col-md-6">
                    {loader ? (
                      <center>
                        <Spinner
                          animation="border"
                          className="d-flex justify-content-center"
                        />
                      </center>
                    ) : (
                      <button
                        className="steps-btn float-right"
                        type="submit"
                        onClick={() => setTouchedError(true)}
                      >
                        Next
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepFour;
